export const InitialValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirm_password: "",
  companyName: "",
  subDomain: "",
  phoneNumber: "",
  state: "",
  city: "",
  selectedPlan: "",
  numberOfUsers: 1,
  selectedCoupon: "",
  // Billing Address Fields
  billing_address_line_1: "",
  billing_address_line_2: "",
  billing_country: "",
  billing_city: "",
  billing_zip_code: "",
  // Company Address Fields
  company_address_line_1: "",
  company_address_line_2: "",
  company_country: "",
  company_city: "",
  company_zip_code: "",
  same_as_billing_address: false,
};


export const defaultValues = {
  address_line_1: '',
  address_line_2: '',
  country: '',
  city: '',
  zip_code: '',
  same_as_billing_address: false,
  company_address_line_1: '',
  company_address_line_2: '',
  company_country: '',
  company_city: '',
  company_zip_code: '',
};